import activity from './activity.pt.json';
import assets from './assets.pt.json';
import auth from './auth.pt.json';
import commissions from './commissions.pt.json';
import common from './common.pt.json';
import dashboard from './dashboard.pt.json';
import payouts from './payouts.pt.json';
import profile from './profile.pt.json';
import rewards from './rewards.pt.json';
import rewardsV3 from './rewardsV3.pt.json';
import shareLink from './shareLink.pt.json';
import stats from './stats.pt.json';
import transactions from './transactions.pt.json';

const pt = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default pt;
